import React, { memo } from 'react';
import TooltipHelpButton from '../../buttons/TooltipHelpButton/TooltipHelpButton';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = () => ({
    title: {
        display: 'flex',
        alignItems: 'center'
    }
});

const SliderTitle = memo(({ title, classes, toolTip }) => {
    return (
        <Typography className={classes.title} gutterBottom variant='body2' style={{ fontWeight: 'inherit' }}>
            {title}
            {toolTip && <TooltipHelpButton title={toolTip} />}
        </Typography>
    );
});

export default withStyles(SliderTitle, styles);